const UNAVAILABLE_LABELS: Record<string, string> = {
  ai_budget_disabled: 'Расходы на ИИ отключены установленным нулевым лимитом.',
  ai_budget_exhausted: 'Месячный бюджет ИИ исчерпан.',
  ai_price_unknown: 'Нет подтверждённой цены для выбранной модели; внешние вызовы отключены.',
  integration_disabled: 'Внешние интеграции отключены в настройках сервера.',
}

/** Present backend Decimal strings as readable RUB without treating unknown as zero. */
export function formatRub(value: string | null): string {
  if (value === null) return 'Неизвестно'
  const amount = Number(value)
  if (!Number.isFinite(amount)) return 'Неизвестно'
  if (amount > 0 && amount < 0.01) return '<0,01 ₽'
  const number = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(amount)
  return `${number.replace(/[\u00a0\u202f]/g, ' ')} ₽`
}

export function formatLimitRub(value: string | null): string {
  return value === null ? 'Безлимит' : formatRub(value)
}

export function formatRemainingRub(remaining: string | null, limit: string | null): string {
  if (remaining === null) return limit === null ? 'Безлимит' : 'Неизвестно'
  return formatRub(remaining)
}

export function formatAiReason(reason: string | null | undefined): string {
  return (reason && UNAVAILABLE_LABELS[reason]) || 'ИИ сейчас недоступен.'
}
